import { render, staticRenderFns } from "./BlockInfos.vue?vue&type=template&id=12d4e442&scoped=true&"
import script from "./BlockInfos.vue?vue&type=script&lang=js&"
export * from "./BlockInfos.vue?vue&type=script&lang=js&"
import style0 from "./BlockInfos.vue?vue&type=style&index=0&id=12d4e442&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d4e442",
  null
  
)

export default component.exports